import { userHasRight } from "../../../framework";
import { toolTip } from "../../controls/toolTip";
import { ll } from "../../core/ll";
import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_Input from "../templates/K_Input";
import { ComponentOptions, RightLockable } from "./component";
import { InputOptions } from "./input";
import { TemplateComponent } from "./templateComponent";

export interface TimeInputOptions extends InputOptions, kendo.ui.TimePickerOptions {
    useAbsoluteTime?: boolean | "true";
    readOnly?: boolean;
    bindId?: string;
    searchType?: string | any;
    requiredRight?: string;
}

export class TimeInput extends TemplateComponent {

    options: TimeInputOptions & RightLockable;

    constructor(options: TimeInputOptions) {
        super(K_Input, options);
    }

    preRender() {
        const options = this.options;

        // Set defaults for woop fields
        if (options.labelAbove) {
            options.bsc = options.bsc || " ";
            if (options.valueWidth) {
                options.containerWidth = options.containerWidth || +options.valueWidth + 10;
                options.labelWidth = options.labelWidth || options.valueWidth;
            }
            options.labelAbove = buildDataBindSyntax(options.labelAbove, "text");
        }

        options.label = buildDataBindSyntax(options.label, "text");
        options.title = buildDataBindSyntax(options.label, "text");
        options.required = options.required || false;
        options.bindValue = options.useAbsoluteTime ? buildDataBindSyntax(options.bindValue, "absoluteTime") : buildDataBindSyntax(options.bindValue, "time");
        options.format = kendo.culture().calendar.patterns.t;
        options.interval = options.interval || 15;
        options.containerClasses = options.containerClasses || "";
        options.containerBind = buildDataBindSyntax(options.containerBind, "container");
        options.bsc = options.bsc || "col-lg-3 col-md-4 col-xs-6";
        options.labelBsc = options.labelBsc || "col-xs-5";
        options.inputBsc = options.inputBsc || "col-xs-7  no-pad";
        options.iconType = options.iconType || "";
        options.iconId = options.iconId || "";
        options.iconClasses = options.iconClasses || "";
        options.iconInput = options.iconType ? "icon-input" : "";

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.readOnly = true;
                options.disabled = true;
                options.classes += " right-locked";
                options.containerClasses += " right-locked";
            }
        }
    }

    create() {
        if (this.options.infoTooltip || this.options.infoTooltipContent) {
            toolTip({
                alignX: "center",
                alignY: "top",
                alignTo: "target",
                offsetY: 5,
                selector: $(`#${this.id}_info`),
                content: this.options.infoTooltip ? ll(this.options.infoTooltip) : this.options.infoTooltipContent
            });
        }

        const options = this.options;

        var timePicker = $("#" + this.id).kendoTimePicker(options).data("kendoTimePicker");

        if (options.disabled && timePicker) {
            timePicker.enable(!options.disabled);
        }

        if ((options.readonly || options.readOnly) && timePicker) {
            timePicker.readonly(true);
        }

        if (timePicker) {
            var isOpen = false;
            timePicker.bind("open", function () {
                isOpen = true;
            });

            timePicker.bind("close", function () {
                isOpen = false;
            });

            timePicker.element.tie("click", function () {
                if ($(this).parent().hasClass("k-state-focused")) {
                    if (isOpen) {
                        timePicker.close();
                    } else {
                        timePicker.open();
                    }
                }
            });
        }
    }

}
